module.exports={
  "name": "aframe-core",
  "version": "0.1.6",
  "homepage": "https://github.com/aframevr/aframe-core",
  "license": "MIT",
  "main": "src/index.js",
  "dependencies": {
    "debug": "^2.2.0",
    "document-register-element": "^0.5.2",
    "es6-promise": "^3.0.2",
    "object-assign": "^4.0.1",
    "present": "0.0.6",
    "request-interval": "^1.0.0",
    "style-attr": "^1.0.1",
    "three-dev": "^0.74.0-beta8",
    "tween.js": "^15.0.0",
    "webvr-polyfill": "github:borismus/webvr-polyfill#3f47796"
  },
  "devDependencies": {
    "browserify": "^11.0.1",
    "browserify-css": "^0.8.2",
    "budo": "^7.0.2",
    "chai-shallow-deep-equal": "^1.3.0",
    "exorcist": "^0.4.0",
    "gh-pages": "^0.4.0",
    "husky": "^0.10.1",
    "karma": "^0.13.15",
    "karma-browserify": "^4.4.0",
    "karma-chai-shallow-deep-equal": "0.0.4",
    "karma-env-preprocessor": "^0.1.1",
    "karma-firefox-launcher": "^0.1.6",
    "karma-mocha": "^0.2.0",
    "karma-mocha-reporter": "^1.1.0",
    "karma-sinon-chai": "^1.1.0",
    "mocha": "^2.3.3",
    "mozilla-download": "^1.0.5",
    "replace": "^0.3.0",
    "semistandard": "^7.0.2",
    "snazzy": "^2.0.1",
    "uglifyjs": "^2.4.10"
  },
  "scripts": {
    "start": "npm run dev",
    "dev": "npm run build && budo src/index.js:build/aframe-core.js --debug --verbose --port 9001 --onupdate 'semistandard -v $(git ls-files \"*.js\") | snazzy' -- ./src/index.js -s 'aframe-core'",
    "browserify": "browserify ./src/index.js -s 'aframe-core'",
    "build": "mkdir -p build/ && npm run browserify -- --debug -o build/aframe-core.js",
    "dist": "rm -rf dist/ && mkdir -p dist/ && npm run dist:js",
    "dist:js": "npm run browserify -s -- --debug | exorcist dist/aframe-core.js.map > dist/aframe-core.js && uglifyjs dist/aframe-core.js -c warnings=false -m -o dist/aframe-core.min.js",
    "preghpages": "npm run dist && rm -rf gh-pages && mkdir -p gh-pages && cp -r {.nojekyll,dist,lib,examples,style,index.html} gh-pages/. && git checkout dist/ && replace 'build/aframe-core.js' 'dist/aframe-core.min.js' gh-pages/ -r --silent",
    "ghpages": "node ./scripts/gh-pages",
    "gh-pages": "npm run ghpages",
    "version": "npm run dist",
    "release:bump": "npm version patch --preminor && git commit -a -C HEAD --amend",
    "release:push": "npm login && npm publish && git push --follow-tags",
    "test": "karma start ./tests/karma.conf.js",
    "test:ci": "TEST_ENV=ci karma start ./tests/karma.conf.js --single-run",
    "lint": "semistandard -v $(git ls-files '*.js') | snazzy",
    "precommit": "npm run lint"
  },
  "repository": {
    "type": "git",
    "url": "git+https://github.com/aframevr/aframe-core.git"
  },
  "bugs": {
    "url": "https://github.com/aframevr/aframe-core/issues"
  },
  "semistandard": {
    "ignore": [
      "dist/**",
      "examples/_js/**",
      "lib/vendor/**",
      "src/shaders/**"
    ]
  },
  "browserify": {
    "transform": [
      "browserify-css"
    ]
  },
  "browserify-css": {
    "minify": true
  },
  "engines": {
    "node": ">= 0.12.7",
    "npm": ">= 2.12.1"
  },
  "gitHead": "b951d8d5de537fa75443587bff979a7fd9427b6b",
  "description": "> `aframe-core` has merged into [aframe dev branch](https://github.com/aframevr/aframe/tree/dev) and all development has moved to the [aframe repo](https://github.com/aframevr/aframe). This repository will be removed later.",
  "_id": "aframe-core@0.1.6",
  "_shasum": "fcb04280ee32b62f276013c9238022ac933f8546",
  "_from": "aframe-core@0.1.6",
  "_npmVersion": "2.11.2",
  "_nodeVersion": "0.12.6",
  "_npmUser": {
    "name": "ngokevin",
    "email": "me@ngokevin.com"
  },
  "dist": {
    "shasum": "fcb04280ee32b62f276013c9238022ac933f8546",
    "tarball": "http://registry.npmjs.org/aframe-core/-/aframe-core-0.1.6.tgz"
  },
  "maintainers": [
    {
      "name": "caseyyee",
      "email": "caseyyee.ca@gmail.com"
    },
    {
      "name": "cvan",
      "email": "hearcomestreble@gmail.com"
    },
    {
      "name": "dmarcos",
      "email": "diego.marcos@gmail.com"
    },
    {
      "name": "mozvr",
      "email": "cvan@mozilla.com"
    },
    {
      "name": "ngokevin",
      "email": "me@ngokevin.com"
    }
  ],
  "_npmOperationalInternal": {
    "host": "packages-13-west.internal.npmjs.com",
    "tmp": "tmp/aframe-core-0.1.6.tgz_1457747622022_0.8922319989651442"
  },
  "directories": {},
  "_resolved": "https://registry.npmjs.org/aframe-core/-/aframe-core-0.1.6.tgz"
}
